export default __webpack_public_path__ + "static/floor-6c2e9f2e3b07f8c0bc9a21a97408e506.jpeg";